'use strict';
(function () {
  angular.module('pentaApp').factory('giveCard.resource', service);

  service.$inject = ['$resource'];
  function service($resource) {
    return $resource('/progressiveApp/api/giveCard');
  }
})();
